import React from "react";
import {Modal} from "antd";
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";

interface PartnerMapProps {
    latitude: number | undefined,
    longitude: number | undefined,
    visible: boolean,
    setVisible: (visible: boolean) => void
}

const PartnerMap: React.FC<PartnerMapProps> = ({latitude, longitude, visible, setVisible}) => {

    const hasCoordinates = latitude != null && longitude != null

    return <Modal
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        centered
        mask={true}
        width={900}
        destroyOnClose
    >
        {hasCoordinates ? (
            <YMaps>
                <Map
                    state={
                        {
                            center: [latitude, longitude],
                            zoom: 11
                        }
                    }
                    width={"100%"}
                    height={"450px"}
                >
                    <Placemark geometry={[latitude, longitude]}/>
                </Map>
            </YMaps>
        ) : (
            <p style={{textAlign: "center", padding: "2rem 0"}}>Локация не указана</p>
        )}
    </Modal>
}

export default PartnerMap;